document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.featured-collection-carousel');
  const toggleBtns = document.querySelectorAll('.toggle-btn');
  // Section wrappers for the toggle "views" on the main page. Each carries
  // data-toggle-view="creator|itbm". Present only on the home page.
  const viewEls = Array.from(document.querySelectorAll('[data-toggle-view]'))
    .filter((el) => ['creator', 'itbm'].includes(el.dataset.toggleView));
  const hasViews = viewEls.length > 0;

  // Store original items for each carousel
  carousels.forEach(carousel => {
    const track = carousel.querySelector('.carousel-track');
    const items = Array.from(track.querySelectorAll('.carousel-item'));

    // Store the raw HTML of items to easily rebuild
    carousel.originalItems = items.map(item => ({
      element: item.cloneNode(true),
      tags: (item.getAttribute('data-tags') || '').split(',').map(t => t.trim())
    }));

    initCarousel(carousel);
  });

  function filterToView(filter) {
    if (filter === 'itbm') return 'itbm';
    return 'creator';
  }

  // Show one view, hide the others, sync the toggle's active state, and reset any
  // carousels inside the newly-shown view (their width was 0 while hidden).
  function showView(view) {
    viewEls.forEach((el) => {
      const match = el.dataset.toggleView === view;
      // Use an explicit 'block' (not '') so it overrides the CSS pre-hide rule
      // ([data-toggle-view="itbm"] { display: none }). Setting '' would just fall
      // back to that rule and leave the view hidden.
      el.style.display = match ? 'block' : 'none';
      if (match) {
        el.querySelectorAll('.featured-collection-carousel').forEach((c) => {
          if (c.controller) c.controller.reset();
        });
      }
    });
    toggleBtns.forEach((b) => {
      const v = filterToView(b.getAttribute('data-filter'));
      b.classList.toggle('active', v === view);
    });
    positionThumbs();
  }

  // Slide a pill behind the active toggle button. Measured per-button so the
  // different label widths ("Creator Store" vs "ITBM Merch") always line up.
  function positionThumbs() {
    document.querySelectorAll('.collection-toggle').forEach(function (toggle) {
      let thumb = toggle.querySelector('.collection-toggle__thumb');
      if (!thumb) {
        thumb = document.createElement('span');
        thumb.className = 'collection-toggle__thumb';
        thumb.setAttribute('aria-hidden', 'true');
        thumb.style.transition = 'none'; // don't animate the very first placement
        toggle.insertBefore(thumb, toggle.firstChild);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            thumb.style.transition = '';
          });
        });
      }
      const active = toggle.querySelector('.toggle-btn.active') || toggle.querySelector('.toggle-btn');
      if (!active || !active.offsetWidth) {
        thumb.style.opacity = '0';
        return;
      }
      thumb.style.opacity = '1';
      thumb.style.width = active.offsetWidth + 'px';
      thumb.style.transform = 'translateX(' + active.offsetLeft + 'px)';
    });
  }

  // A one-time view request stashed by an off-page toggle click. Read once and
  // cleared, so it never persists — a refresh always returns to the default view.
  function takeRequestedView() {
    try {
      const v = sessionStorage.getItem('itbm-view');
      if (v) sessionStorage.removeItem('itbm-view');
      return v;
    } catch (e) {
      return null;
    }
  }

  // Initial view: honor a one-time off-page request, otherwise the default
  // Creator Store view. Nothing is stored in the URL, so a refresh always resets
  // to Creator Store.
  if (hasViews) {
    const requested = takeRequestedView();
    const initialView = requested === 'itbm' ? 'itbm' : 'creator';
    showView(initialView);
  }

  // Toggle clicks: on the main page swap the visible view in place — no URL change,
  // so refreshing goes back to the default Creator Store view. On other pages, stash
  // the requested view and go to the home page to show it once.
  toggleBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      const filter = this.getAttribute('data-filter');
      const view = filterToView(filter);

      if (hasViews) {
        // Already-active view stays put; otherwise swap to the clicked view.
        showView(view);
      } else {
        try {
          sessionStorage.setItem('itbm-view', view);
        } catch (e) {
          /* private mode / storage disabled — just navigate home */
        }
        window.location.href = '/';
      }
    });
  });

  // Place the thumb on load (covers pages where showView isn't called), after web
  // fonts settle, and on resize / when the mobile vs desktop toggle swaps in.
  positionThumbs();
  window.addEventListener('load', positionThumbs);
  window.addEventListener('resize', positionThumbs);

  // (The old tag-based filterCarousel was replaced by the view-swap model above.)

  function initCarousel(carousel) {
    if (carousel.isInitialized) return;

    const track = carousel.querySelector('.carousel-track');
    const prevBtn = carousel.querySelector('.carousel-nav-dot.prev') || carousel.querySelector('.carousel-arrow.prev');
    const nextBtn = carousel.querySelector('.carousel-nav-dot.next') || carousel.querySelector('.carousel-arrow.next');
    const dotsContainer = carousel.querySelector('.carousel-dots');

    let currentPage = 0;
    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = 0;

    // Expose reset function
    carousel.controller = {
      reset: () => {
        currentPage = 0;
        const pages = carousel.querySelectorAll('.carousel-page');

        // Hide controls if 1 or 0 pages
        if (pages.length <= 1) {
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
          if (dotsContainer) dotsContainer.style.display = 'none';
        } else {
          if (prevBtn) prevBtn.style.display = 'flex';
          if (nextBtn) nextBtn.style.display = 'flex';
          if (dotsContainer) dotsContainer.style.display = 'flex';
          createDots();
        }

        if (pages.length > 0) {
          track.scrollTo({ left: 0 });
          updateButtons();
        }
      }
    };

    function createDots() {
      const pages = carousel.querySelectorAll('.carousel-page');
      if (!dotsContainer) return;
      dotsContainer.innerHTML = ''; // Clear existing dots

      if (pages.length <= 1) return;

      pages.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('carousel-dot');
        dot.setAttribute('aria-label', `Go to page ${index + 1}`);
        if (index === 0) dot.classList.add('active');

        dot.addEventListener('click', () => goToPage(index));
        dotsContainer.appendChild(dot);
      });
    }

    function goToPage(pageIndex) {
      const pages = carousel.querySelectorAll('.carousel-page');
      if (pages.length === 0) return;

      currentPage = Math.max(0, Math.min(pageIndex, pages.length - 1));
      const scrollAmount = pages[currentPage].offsetLeft - track.offsetLeft;
      track.scrollTo({
        left: scrollAmount,
        behavior: 'smooth'
      });
      updateDots();
      updateButtons();
    }

    function updateDots() {
      if (!dotsContainer) return;
      const dots = dotsContainer.querySelectorAll('.carousel-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentPage);
      });
    }

    function updateButtons() {
      const pages = carousel.querySelectorAll('.carousel-page');
      if (prevBtn) prevBtn.disabled = currentPage === 0;
      if (nextBtn) nextBtn.disabled = currentPage === pages.length - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentPage > 0) goToPage(currentPage - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const pages = carousel.querySelectorAll('.carousel-page');
        if (currentPage < pages.length - 1) goToPage(currentPage + 1);
      });
    }

    track.addEventListener('scroll', () => {
      if (!isDragging) {
        const pages = carousel.querySelectorAll('.carousel-page');
        if (pages.length === 0) return;

        const scrollPosition = track.scrollLeft;
        const pageWidth = pages[0].offsetWidth;
        const newPage = Math.round(scrollPosition / pageWidth);

        if (newPage !== currentPage) {
          currentPage = newPage;
          updateDots();
          updateButtons();
        }
      }
    });

    // Touch events
    function touchStart(event) {
      isDragging = true;
      startPos = getPositionX(event);
      animationID = requestAnimationFrame(animation);
      track.classList.add('dragging');
    }

    function touchMove(event) {
      if (isDragging) {
        const currentPosition = getPositionX(event);
        currentTranslate = prevTranslate + currentPosition - startPos;
      }
    }

    function touchEnd() {
      isDragging = false;
      cancelAnimationFrame(animationID);
      track.classList.remove('dragging');

      const movedBy = currentTranslate - prevTranslate;
      const pages = carousel.querySelectorAll('.carousel-page');

      if (movedBy < -100 && currentPage < pages.length - 1) {
        currentPage += 1;
      }

      if (movedBy > 100 && currentPage > 0) {
        currentPage -= 1;
      }

      goToPage(currentPage);
      prevTranslate = currentTranslate;
    }

    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    function animation() {
      if (isDragging) requestAnimationFrame(animation);
    }

    track.addEventListener('mousedown', touchStart);
    track.addEventListener('touchstart', touchStart);
    track.addEventListener('mousemove', touchMove);
    track.addEventListener('touchmove', touchMove);
    track.addEventListener('mouseup', touchEnd);
    track.addEventListener('mouseleave', touchEnd);
    track.addEventListener('touchend', touchEnd);

    track.addEventListener('dragstart', (e) => e.preventDefault());

    window.addEventListener('resize', () => {
      goToPage(currentPage);
    });

    // Initial setup
    carousel.isInitialized = true;
    carousel.controller.reset();
  }
});
